import { render, staticRenderFns } from "./agingStockStats.vue?vue&type=template&id=a2b3008e&scoped=true"
import script from "./agingStockStats.vue?vue&type=script&lang=js"
export * from "./agingStockStats.vue?vue&type=script&lang=js"
import style0 from "./agingStockStats.vue?vue&type=style&index=0&id=a2b3008e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b3008e",
  null
  
)

export default component.exports